<template>
    <div class="container">
      <img :src="'http://9game.laolongtang.com.cn/uploads/mark_picture/'+Id+'.jpg'" />
    </div>
  </template>
  
  <script>
  export default {
    name: 'UserCertificate',
    data () {
      return {
        Id:0
      }
    },
    methods: {
      chgK(){
        console.log(this.checked)
      }
    },
    created () {
        document.title = '完赛证书'
        this.Id = this.$route.params.id
        console.log(this.Id)
    },
    mounted () {
  
    }
  }
  </script>
  
  <style lang="less" scoped>
  .container {
    height: 100vh;
    overflow: auto;
    background: #fff;
    padding: 0;
    box-sizing: border-box;
  
    img {
      width: 100%;
    }
  }
  </style>
  